<template>
  <div class="limiter">
    <div class="container-login">
      <v-container fluid>
        <v-row align="center" justify="center">
          <v-col cols="12" sm="12" md="6" lg="6">
            <v-card class="login" flat style="border-radius: 10px;padding: 10px;">
              <span class="login-title">
                <img src="../assets/logoAiConsumer.png" width="100%" style="max-width: 300px">
              </span>
              <v-card-text style="padding: 0px; margin-top: 0px;">
                <v-container fluid grid-list-md>
                  <v-layout row wrap justify-center>
                    <v-flex xs12 sm12 lg12>
                      <!-- <v-text-field label="Informe o valor" outlined hide-details v-model="valorTransacao" prefix="R$" type="tel" color="#474d55" dense id="campoValor" v-mask="'##,##'"></v-text-field> -->
                      <v-text-field label="Informe o valor" outlined hide-details v-model="valorTransacao" prefix="R$" color="#474d55" dense id="campoValor" readonly></v-text-field>
                      <!-- <vuetify-money v-model="valorTransacao" label="Valor" :disabled="disabled" :outlined="outlined" :clearable="false" :valueWhenIsEmpty="valueWhenIsEmpty" :options="options" hideDetails="true" :dense="true" :readonly="true" /> -->
                      <p style="margin: 0px">Valor mínimo para recargas: R$10,00</p>
                    </v-flex>
                    <!-- <v-flex xs12 sm12 lg12>
                      <v-row dense>
                        <v-col cols="3">
                          <v-btn outlined @click="alteraValor(1)" block text style="width: 100%">+1</v-btn>
                        </v-col>
                        <v-col cols="3">
                          <v-btn outlined @click="alteraValor(10)" block text style="width: 100%">+10</v-btn>
                        </v-col>
                        <v-col cols="3">
                          <v-btn outlined @click="alteraValor(50)" block text style="width: 100%">+50</v-btn>
                        </v-col>
                        <v-col cols="3">
                          <v-btn outlined @click="alteraValor(100)" block text style="width: 100%">+100</v-btn>
                        </v-col>
                      </v-row>
                    </v-flex> -->
                    <v-card style="margin: 5px" outlined>
                      <v-row dense style="margin: 5px">
                        <v-col cols="4">
                          <v-btn block color="#ddd" @click="handleKeyPress('1', 'valorTransacao')" large>1</v-btn>
                        </v-col>
                        <v-col cols="4">
                          <v-btn block color="#ddd" @click="handleKeyPress('2', 'valorTransacao')" large>2</v-btn>
                        </v-col>
                        <v-col cols="4">
                          <v-btn block color="#ddd" @click="handleKeyPress('3', 'valorTransacao')" large>3</v-btn>
                        </v-col>
                        <v-col cols="4">
                          <v-btn block color="#ddd" @click="handleKeyPress('4', 'valorTransacao')" large>4</v-btn>
                        </v-col>
                        <v-col cols="4">
                          <v-btn block color="#ddd" @click="handleKeyPress('5', 'valorTransacao')" large>5</v-btn>
                        </v-col>
                        <v-col cols="4">
                          <v-btn block color="#ddd" @click="handleKeyPress('6', 'valorTransacao')" large>6</v-btn>
                        </v-col>
                        <v-col cols="4">
                          <v-btn block color="#ddd" @click="handleKeyPress('7', 'valorTransacao')" large>7</v-btn>
                        </v-col>
                        <v-col cols="4">
                          <v-btn block color="#ddd" @click="handleKeyPress('8', 'valorTransacao')" large>8</v-btn>
                        </v-col>
                        <v-col cols="4">
                          <v-btn block color="#ddd" @click="handleKeyPress('9', 'valorTransacao')" large>9</v-btn>
                        </v-col>
                        <v-col cols="4">
                          <v-btn block color="#ddd" @click="handleKeyPress('clear', 'valorTransacao')" large>
                            <v-icon>mdi-alpha-c-circle-outline</v-icon>
                          </v-btn>
                        </v-col>
                        <v-col cols="4">
                          <v-btn block color="#ddd" @click="handleKeyPress('0', 'valorTransacao')" large>0</v-btn>
                        </v-col>
                        <v-col cols="4">
                          <v-btn block color="#ddd" @click="handleKeyPress('backspace', 'valorTransacao')" large>
                            <v-icon>mdi-backspace-outline</v-icon>
                          </v-btn>
                        </v-col>
                      </v-row>
                    </v-card>
                    <!-- <v-flex xs12 sm12 lg12>
                      <v-btn depressed block outlined large style="border-radius: 7px; width: 100%" @click="abreLeituraQRCode('DEPÓSITO', 'CARTÃO')">
                        <v-icon left size="25">mdi-credit-card</v-icon>Recarga em Cartão
                      </v-btn>
                    </v-flex> -->
                    <v-flex xs12 sm12 lg12>
                      <v-btn depressed block outlined large style="border-radius: 7px; width: 100%" @click="abreLeituraQRCode('DEPÓSITO', 'PIX')">
                        <img style="margin-right: 5px" src="../assets/pix.png" width="18px">Recarga em Pix
                      </v-btn>
                    </v-flex>
                    <v-flex xs12 sm12 lg12>
                      <v-btn depressed block outlined large style="border-radius: 7px; width: 100%" @click="consultarSaldo">
                        <v-icon left size="25">mdi-magnify</v-icon>Consultar Saldo
                      </v-btn>
                    </v-flex>
                    <v-flex xs12 sm12 lg12>
                      <v-btn depressed block outlined large style="border-radius: 7px; width: 100%" @click="solicitaResgate">
                        <v-icon left size="25">mdi-currency-usd</v-icon>Solicitar Resgate
                      </v-btn>
                    </v-flex>
                  </v-layout>
                </v-container>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>
        <br>
        <div class="login-title">
          <img src="../assets/logo-branco-orizontal.png" width="150px">
        </div>
      </v-container>

      <v-dialog persistent v-model="dialogoCaptura" max-width="600px">
        <v-card>
          <v-card-title>Leitura do QR Code</v-card-title>
          <v-card-text style="padding: 0px" v-if="tipoLeitura == 'CÂMERA'">
            <qrcode-stream @decode="decodificar" v-if="dialogoCaptura"></qrcode-stream>
          </v-card-text>
          <v-card-text style="padding-bottom: 0px" v-if="tipoLeitura == 'LEITOR'">
            <v-row>
              <v-col cols="12" style="text-align: center">
                <v-icon size="100">mdi-qrcode-scan</v-icon>
                <p style="margin: 10px 0px 0px 0px; font-size: 17px">Aproxime o QR Code do leitor</p>
              </v-col>
              <v-col cols="12" style="position: absolute; left: -99999px;">
                <v-text-field v-model="codigoQrCode" id="campoCaptura" @keydown.enter="decodificar(codigoQrCode)"></v-text-field>
              </v-col>
            </v-row>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn text color="red" @click="fechar">Fechar</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-dialog persistent v-model="dialogoConsultaSaldo" max-width="600px">
        <v-card>
          <v-card-title>Leitura do QR Code</v-card-title>
          <v-card-text style="padding: 0px" v-if="tipoLeitura == 'CÂMERA'">
            <qrcode-stream @decode="fazerConsultaSaldo" v-if="dialogoConsultaSaldo"></qrcode-stream>
          </v-card-text>
          <v-card-text style="padding-bottom: 0px" v-if="tipoLeitura == 'LEITOR'">
            <v-row>
              <v-col cols="12" style="text-align: center">
                <v-icon size="100">mdi-qrcode-scan</v-icon>
                <p style="margin: 10px 0px 0px 0px; font-size: 17px">Aproxime o QR Code do leitor</p>
              </v-col>
              <v-col cols="12" style="position: absolute; left: -99999px;">
                <v-text-field v-model="codigoQrCode" id="campoConsultaSaldo" @keydown.enter="fazerConsultaSaldo(codigoQrCode)"></v-text-field>
              </v-col>
            </v-row>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn text color="red" @click="fechar">Fechar</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-dialog persistent v-model="dialogoSolicitaResgate" max-width="600px">
        <v-card>
          <v-card-title>Leitura do QR Code</v-card-title>
          <v-card-text style="padding: 0px" v-if="tipoLeitura == 'CÂMERA'">
            <qrcode-stream @decode="fazerSolitacaoResgate" v-if="dialogoSolicitaResgate"></qrcode-stream>
          </v-card-text>
          <v-card-text style="padding-bottom: 0px" v-if="tipoLeitura == 'LEITOR'">
            <v-row>
              <v-col cols="12" style="text-align: center">
                <v-icon size="100">mdi-qrcode-scan</v-icon>
                <p style="margin: 10px 0px 0px 0px; font-size: 17px">Aproxime o QR Code do leitor</p>
              </v-col>
              <v-col cols="12" style="position: absolute; left: -99999px;">
                <v-text-field v-model="codigoQrCode" id="campoSolicitaResgate" @keydown.enter="fazerSolitacaoResgate(codigoQrCode)"></v-text-field>
              </v-col>
            </v-row>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn text color="red" @click="fechar">Fechar</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-dialog persistent v-model="dialogoSolicitaPin" max-width="400px">
        <v-card>
          <v-card-title>Informe seu PIN</v-card-title>
          <v-card-text style="padding-bottom: 0px">
            <p>Informe o código PIN para continuar</p>
            <v-otp-input id="pinTransacao" length="4" color="#474d55" type="number" v-model="pinTransacao"></v-otp-input>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn text color="primary" @click="fechar">Fechar</v-btn>
            <v-btn text color="primary" :disabled="pinTransacao.length < 4" @click="criarTransacao">Continuar</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-dialog persistent v-model="dialogoOperacao" max-width="600px">
        <v-card>
          <v-card-text style="padding-bottom: 0px; text-align: center">
            <v-icon size="100" :color="respostaTransacao.resultado == 'SUCESSO' ? 'success' : 'error'">{{ respostaTransacao.resultado == 'SUCESSO' ? 'check_circle' : 'error' }}</v-icon>
            <h1 style="margin: 0px; font-weight: 300">{{ respostaTransacao.consumidor }}</h1>
            <h3 style="margin-bottom: 0px; margin-top: 10px">Saldo</h3>
            <h1 style="margin: 0px; font-weight: 300; margin-top: 10px">R$ {{ respostaTransacao.saldo }}</h1>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn text color="red" @click="fechar">Fechar</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-dialog persistent v-model="dialogoCadastraConsumidor" max-width="600px">
        <v-card>
          <v-card-title>Cadastrar Consumidor</v-card-title>
          <v-card-subtitle style="color: blue">Preenchimento opcional</v-card-subtitle>
          <v-card-text style="padding-bottom: 0px">
            <v-row dense>
              <v-col cols="12">
                <v-text-field label="CPF" outlined dense hide-details v-model="consumidor.cpf" v-validate="'required|cpf'" data-vv-name="cpf" type="tel" v-mask="'###.###.###-##'" @focus="focusInput('consumidor.cpf')"></v-text-field>
              </v-col>
              <v-col cols="12">
                <v-text-field label="Nome e sobrenome" outlined dense hide-details v-model="consumidor.nome" @focus="focusInput('consumidor.nome')"></v-text-field>
              </v-col>
              <v-col cols="12">
                <v-text-field label="WhatsApp com DDD" outlined dense v-model="consumidor.whatsApp" @focus="focusInput('consumidor.whatsApp')" persistent-hint hint="As notificações serão enviadas para o número informado"></v-text-field>
              </v-col>
            </v-row>
            <v-row>
              <CompleteKeyboard v-if="tecladoNomeConsumidor" @onChange="onChangeValor" :input="consumidor.nome" />
              <!-- TECLADO CPF -->
              <v-card style="margin: 5px" outlined v-if="tecladoCPFConsumidor">
                <v-row dense style="margin: 5px">
                  <v-col cols="4">
                    <v-btn block color="#ddd" @click="handleKeyPress('1', 'consumidor.cpf')" large>1</v-btn>
                  </v-col>
                  <v-col cols="4">
                    <v-btn block color="#ddd" @click="handleKeyPress('2', 'consumidor.cpf')" large>2</v-btn>
                  </v-col>
                  <v-col cols="4">
                    <v-btn block color="#ddd" @click="handleKeyPress('3', 'consumidor.cpf')" large>3</v-btn>
                  </v-col>
                  <v-col cols="4">
                    <v-btn block color="#ddd" @click="handleKeyPress('4', 'consumidor.cpf')" large>4</v-btn>
                  </v-col>
                  <v-col cols="4">
                    <v-btn block color="#ddd" @click="handleKeyPress('5', 'consumidor.cpf')" large>5</v-btn>
                  </v-col>
                  <v-col cols="4">
                    <v-btn block color="#ddd" @click="handleKeyPress('6', 'consumidor.cpf')" large>6</v-btn>
                  </v-col>
                  <v-col cols="4">
                    <v-btn block color="#ddd" @click="handleKeyPress('7', 'consumidor.cpf')" large>7</v-btn>
                  </v-col>
                  <v-col cols="4">
                    <v-btn block color="#ddd" @click="handleKeyPress('8', 'consumidor.cpf')" large>8</v-btn>
                  </v-col>
                  <v-col cols="4">
                    <v-btn block color="#ddd" @click="handleKeyPress('9', 'consumidor.cpf')" large>9</v-btn>
                  </v-col>
                  <v-col cols="4">
                    <v-btn block color="#ddd" @click="handleKeyPress('clear', 'consumidor.cpf')" large>
                      <v-icon>mdi-alpha-c-circle-outline</v-icon>
                    </v-btn>
                  </v-col>
                  <v-col cols="4">
                    <v-btn block color="#ddd" @click="handleKeyPress('0', 'consumidor.cpf')" large>0</v-btn>
                  </v-col>
                  <v-col cols="4">
                    <v-btn block color="#ddd" @click="handleKeyPress('backspace', 'consumidor.cpf')" large>
                      <v-icon>mdi-backspace-outline</v-icon>
                    </v-btn>
                  </v-col>
                </v-row>
              </v-card>
              <v-card style="margin: 5px" outlined v-if="tecladoWhatsAppConsumidor">
                <v-row dense style="margin: 5px">
                  <v-col cols="4">
                    <v-btn block color="#ddd" @click="handleKeyPress('1', 'consumidor.whatsApp')" large>1</v-btn>
                  </v-col>
                  <v-col cols="4">
                    <v-btn block color="#ddd" @click="handleKeyPress('2', 'consumidor.whatsApp')" large>2</v-btn>
                  </v-col>
                  <v-col cols="4">
                    <v-btn block color="#ddd" @click="handleKeyPress('3', 'consumidor.whatsApp')" large>3</v-btn>
                  </v-col>
                  <v-col cols="4">
                    <v-btn block color="#ddd" @click="handleKeyPress('4', 'consumidor.whatsApp')" large>4</v-btn>
                  </v-col>
                  <v-col cols="4">
                    <v-btn block color="#ddd" @click="handleKeyPress('5', 'consumidor.whatsApp')" large>5</v-btn>
                  </v-col>
                  <v-col cols="4">
                    <v-btn block color="#ddd" @click="handleKeyPress('6', 'consumidor.whatsApp')" large>6</v-btn>
                  </v-col>
                  <v-col cols="4">
                    <v-btn block color="#ddd" @click="handleKeyPress('7', 'consumidor.whatsApp')" large>7</v-btn>
                  </v-col>
                  <v-col cols="4">
                    <v-btn block color="#ddd" @click="handleKeyPress('8', 'consumidor.whatsApp')" large>8</v-btn>
                  </v-col>
                  <v-col cols="4">
                    <v-btn block color="#ddd" @click="handleKeyPress('9', 'consumidor.whatsApp')" large>9</v-btn>
                  </v-col>
                  <v-col cols="4">
                    <v-btn block color="#ddd" @click="handleKeyPress('clear', 'consumidor.whatsApp')" large>
                      <v-icon>mdi-alpha-c-circle-outline</v-icon>
                    </v-btn>
                  </v-col>
                  <v-col cols="4">
                    <v-btn block color="#ddd" @click="handleKeyPress('0', 'consumidor.whatsApp')" large>0</v-btn>
                  </v-col>
                  <v-col cols="4">
                    <v-btn block color="#ddd" @click="handleKeyPress('backspace', 'consumidor.whatsApp')" large>
                      <v-icon>mdi-backspace-outline</v-icon>
                    </v-btn>
                  </v-col>
                </v-row>
              </v-card>
            </v-row>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn text color="primary" @click="dialogoCadastraConsumidor = false">Fechar</v-btn>
            <v-btn text color="primary" @click="criarConsumidor">Continuar</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-dialog persistent v-model="dialogoCartao" max-width="800px">
        <v-card>
          <v-card-title style="padding-top: 10px">Pagamento no cartão</v-card-title>
          <v-card-text style="padding-bottom: 0px">
            <v-container style="padding: 5px">
              <v-row dense>
                <v-col cols="12" xs="6" sm="12" md="12" lg="6">
                  <v-text-field v-model="cobrancaAsaasCartao.creditCard.holderName" outlined dense label="Nome impresso no cartão*" hide-details prepend-inner-icon="mdi-account" required></v-text-field>
                </v-col>
                <v-col cols="12" xs="12" sm="12" md="12" lg="6">
                  <v-text-field v-model="cobrancaAsaasCartao.creditCard.number" outlined dense label="Número do cartão*" v-mask="'#### #### #### ####'" type="tel" hide-details prepend-inner-icon="mdi-numeric" required></v-text-field>
                </v-col>
                <v-col cols="6" xs="6" sm="12" md="12" lg="3">
                  <v-text-field v-model="cobrancaAsaasCartao.creditCard.cpfCnpj" outlined dense label="CPF do titular*" v-mask="'###.###.###-##'" v-validate="'required|cpf'" :error-messages="errors.collect('cpftitular')" data-vv-name="cpftitular" type="tel" hide-details prepend-inner-icon="mdi-card-account-details" required></v-text-field>
                </v-col>
                <v-col cols="6" xs="12" sm="12" md="12" lg="3">
                  <v-text-field v-model="cobrancaAsaasCartao.creditCard.ccv" outlined dense label="CVV*" v-mask="'###'" type="password" hide-details prepend-inner-icon="mdi-lock" required></v-text-field>
                </v-col>
                <v-col cols="6" xs="6" sm="6" md="12" lg="3">
                  <v-select v-model="cobrancaAsaasCartao.creditCard.expiryMonth" outlined dense label="Mês de vencimento*" hide-details :items="mesesVencimento" item-text="titulo" item-value="id" prepend-inner-icon="mdi-calendar-month" required></v-select>
                </v-col>
                <v-col cols="6" xs="6" sm="6" md="12" lg="3">
                  <v-select v-model="cobrancaAsaasCartao.creditCard.expiryYear" outlined dense label="Ano de vencimento*" hide-details :items="anosVencimento" item-text="titulo" item-value="id" prepend-inner-icon="mdi-calendar" required></v-select>
                </v-col>
                <v-col cols="12" xs="12" sm="12" md="12" lg="4">
                  <v-select v-model="bandeiraCartao" outlined dense :items="bandeiras" hide-details item-text="text" item-value="value" label="Bandeira*" required></v-select>
                </v-col>
                <v-col cols="12" xs="12" sm="12" md="12" lg="8">
                  <v-select v-model="cobrancaAsaasCartao.value" outlined dense :items="parcelas" hide-details item-text="text" item-value="value" label="Parcelas*" @input="carregaQtdParcelas" required></v-select>
                </v-col>
                <v-col cols="6" xs="12" sm="12" md="12" lg="3">
                  <v-text-field v-model="cobrancaAsaasCartao.creditCardHolderInfo.postalCode" v-mask="'#####-###'" label="CEP*" outlined type="tel" dense hide-details required prepend-inner-icon="mdi-map-marker"></v-text-field>
                </v-col>
                <v-col cols="6" xs="12" sm="12" md="12" lg="3">
                  <v-text-field v-model="cobrancaAsaasCartao.creditCardHolderInfo.addressNumber" label="Nº do Endereço*" outlined type="tel" dense hide-details required></v-text-field>
                </v-col>
                <v-col cols="12" xs="12" sm="12" md="12" lg="6">
                  <v-text-field v-model="cobrancaAsaasCartao.creditCardHolderInfo.email" label="E-mail*" outlined type="mail" dense hide-details required prepend-inner-icon="mdi-at"></v-text-field>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
          <v-card-actions style="padding-top: 0px">
            <v-spacer></v-spacer>
            <v-btn dark @click="dialogoCartao = false" color="primary" text>Voltar</v-btn>
            <v-btn dark color="primary" text>Pagar</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-dialog v-model="dialogoPagamentoPix" persistent max-width="600px">
        <v-card>
          <v-card-title>Pagamento</v-card-title>
          <v-card-text style="text-align: center; padding-bottom: 0px">
            <v-container>
              <v-row align="center" justify="center">
                <v-col cols="12" style="padding: 1px">
                  <v-card flat color="#ffffff">
                    <img :src="cobrancaPix.qrCode" width="100%" style="max-width: 300px">
                  </v-card>
                </v-col>
              </v-row>
              <v-row align="center" justify="center">
                <v-col cols="12" style="padding: 1px;">
                  <p class="texto" style="color: orange">R$ {{valorTransacao}}</p>
                </v-col>
                <v-col cols="12" style="padding: 1px;">
                  <p class="texto" style="color: #00695C" v-if="gatewayPagamentoPix == 'ASAAS'">Nome Fantasia: INTELITE TECNOLOGIA</p>
                  <p class="texto" style="color: #00695C" v-if="gatewayPagamentoPix == 'TAPAGO'">Nome Fantasia: INTELITE TECNOLOGIA FLAGSHIP</p>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn style="border-radius: 7px;" dark depressed block color="#00695C" @click="closeDialog">Fechar</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-dialog v-model="dialogoConfirmacao" persistent max-width="400px">
        <v-card>
          <v-card-text style="text-align: center; padding-bottom: 0px">
            <v-container>
              <v-row align="center" justify="center">
                <v-col cols="12" style="padding-bottom: 0px;">
                  <v-icon color="success" size="100">check_circle</v-icon>
                </v-col>
                <v-col cols="12" style="padding: 2px;">
                  <p class="texto" style="color: #666; margin: 0px">Recarga realizada com sucesso!</p>
                  <p class="texto" style="color: #666; margin: 0px" v-if="saldoCartao">Saldo: R$ {{saldoCartao}}</p>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn text color="primary" @click="closeDialog(true)">Fechar</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-dialog persistent v-model="dialogoDadosResgate" max-width="400px">
        <v-card>
          <v-card-title>Informações para resgate</v-card-title>
          <v-card-text style="padding-bottom: 0px">
            <v-row dense>
              <v-col cols="12">
                <v-radio-group v-model="solicitacaoResgate.tipoChavePix">
                  <p>Tipo de chave Pix</p>
                  <v-radio label="CPF/CNPJ" value="CPF/CNPJ"></v-radio>
                  <v-radio label="E-mail" value="E-MAIL"></v-radio>
                  <v-radio label="Telefone" value="TELEFONE"></v-radio>
                </v-radio-group>
              </v-col>
              <v-col cols="12">
                <v-text-field label="Nome Favorecido Pix" outlined dense hide-details v-model="solicitacaoResgate.favorecidoPix" @focus="focusInput('solicitacaoResgate.favorecidoPix')"></v-text-field>
              </v-col>
              <v-col cols="12">
                <v-text-field label="Chave Pix" outlined dense hide-details v-model="solicitacaoResgate.chavePix" @focus="focusInput('solicitacaoResgate.chavePix')"></v-text-field>
              </v-col>
            </v-row>
            <v-row>
              <CompleteKeyboard v-if="tecladoChavePix" @onChange="digitaChavePix" :input="solicitacaoResgate.chavePix" />
              <CompleteKeyboard v-if="tecladoFavorecidoPix" @onChange="digitaFavorecidoPix" :input="solicitacaoResgate.favorecidoPix" />
            </v-row>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn text color="primary" @click="dialogoDadosResgate = false">Fechar</v-btn>
            <v-btn text color="primary" @click="solicitarResgate" :disabled="solicitacaoResgate.tipoChavePix == '' && solicitacaoResgate.chavePix.length < 7 && solicitacaoResgate.favorecidoPix.length < 7">Continuar</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-dialog v-model="dialogoTipoLeitura" persistent max-width="400px">
        <v-card>
          <v-card-title></v-card-title>
          <v-card-text>
            <v-row>
              <v-col cols="12">
                <v-btn block color="primary" @click="configuraTipoLeitura('CÂMERA')">
                  <v-icon left>mdi-camera</v-icon>Usar câmera
                </v-btn>
              </v-col>
              <v-col cols="12">
                <v-btn block color="#15AAF4" dark @click="configuraTipoLeitura('LEITOR')">
                  <v-icon left>mdi-qrcode</v-icon>Usar leitor
                </v-btn>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-dialog>
    </div>
    <loading :active.sync="isLoading" :can-cancel="true" color="#474d55" :is-full-page="fullPage"></loading>
    <Snackbar ref=chamaSnackbar />
    <v-snackbar v-model="snackbar" :timeout="timeout">
      {{ textoSnackbar }}
      <template v-slot:action="{ attrs }">
        <v-btn color="blue" text v-bind="attrs" @click="snackbar = false">Fechar</v-btn>
      </template>
    </v-snackbar>
  </div>
</template>

<script>
  import Loading from 'vue-loading-overlay';
  import 'vue-loading-overlay/dist/vue-loading.css';
  import { baseApiUrl } from '@/global'
  import Snackbar from '../componentes/snackbar.vue'
  import { mapState } from 'vuex'
  import axios from 'axios'
  import { VMoney } from 'v-money'
  import moment from 'moment'
  import CompleteKeyboard from '../componentes/CompleteKeyboard'
  //import CpfValidate from '../../componentes/validators/rules/cpf'
  export default {
    components: { Snackbar, Loading, CompleteKeyboard, },
    name: 'Caixa',
    data() {
      return {
        timeout: 4000,
        snackbar: false,
        textoSnackbar: '',
        side: 1,
        pinTransacao: '',
        valorTransacao: "0,00",
        tipoTransacao: '',
        formaTransacao: '',
        codigoQrCode: '',
        codigoInscricao: '',
        money: {
          decimal: ',',
          thousands: '.',
          prefix: '',
          suffix: '',
          precision: 2,
          masked: false
        },
        consumidor: {
          nome: '',
          cpf: '',
          whatsApp: '',
          qrCode: '',
        },
        fullPage: true,
        isLoading: false,
        respostaTransacao: [],
        mesesVencimento: ['01', '02', '03', '04', '05', '06', '07', '08', '09', '10', '11', '12'],
        anosVencimento: [],
        bandeiras: [
          { value: 'DINERS', text: "DINERS" },
          { value: 'ELO', text: "ELO" },
          { value: 'HIPERCARD', text: "HIPERCARD" },
          { value: 'MASTERCARD', text: "MASTERCARD" },
          { value: 'VISA', text: "VISA" },
        ],
        cobrancaAsaas: {
          customer: '',
          billingType: 'PIX',
          value: 0,
          dueDate: '',
          description: ''
        },
        cobrancaAsaasCartao: {
          customer: '',
          billingType: 'CREDIT_CARD',
          value: 0,
          dueDate: '',
          description: '',
          remoteIp: '',
          creditCard: {
            holderName: '',
            number: '',
            expiryMonth: '',
            expiryYear: '',
            ccv: ''
          },
          creditCardHolderInfo: {
            name: '',
            email: '',
            cpfCnpj: '',
            postalCode: '',
            addressNumber: '',
            phone: ''
          }
        },
        clienteAsaas: {
          name: '',
          cpfCnpj: '',
          email: '',
          mobilePhone: '',
          postalCode: '',
          addressNumber: '',
          notificationDisabled: true,
        },
        defaultCobrancaAsaas: {
          customer: '',
          billingType: 'PIX',
          value: 0,
          dueDate: '',
          description: ''
        },
        defaultCobrancaAsaasCartao: {
          customer: '',
          billingType: 'CREDIT_CARD',
          value: 0,
          dueDate: '',
          description: '',
          remoteIp: '',
          creditCard: {
            holderName: '',
            number: '',
            expiryMonth: '',
            expiryYear: '',
            ccv: ''
          },
          creditCardHolderInfo: {
            name: '',
            email: '',
            cpfCnpj: '',
            postalCode: '',
            addressNumber: '',
            phone: ''
          }
        },
        cobrancaPix: {
          id: '',
          qrCode: '',
          chaveCopiaCola: '',
        },
        solicitacaoResgate: {
          cpfConsumidor: '',
          qrCodeCartaoConsumo: '',
          tipoChavePix: '',
          chavePix: '',
          favorecidoPix: '',
        },
        parcelas: [],
        qrCode64: '',
        chaveCopiaeCola: '',
        audio: '',
        bandeiraCartao: '',
        dialogoSolicitaPin: false,
        dialogoCaptura: false,
        dialogoCadastraConsumidor: false,
        dialogoOperacao: false,
        dialogoCartao: false,
        dialogoPagamentoPix: false,
        dialogoConfirmacao: false,
        verificaPagamento: '',
        saldoCartao: '',
        tecladoCPFConsumidor: false,
        tecladoNomeConsumidor: false,
        tecladoWhatsAppConsumidor: false,
        dialogoConsultaSaldo: false,
        dialogoSolicitaResgate: false,
        dialogoDadosResgate: false,
        tecladoChavePix: false,
        tecladoFavorecidoPix: false,
        disabled: false,
        outlined: true,
        clearable: false,
        valueWhenIsEmpty: "0,00",
        options: {
          locale: "pt-BR",
          prefix: "R$",
          suffix: "",
          length: 11,
          precision: 2
        },
        layout: "numeric",
        input: null,
        optionsKey: {
          useKbEvents: false,
          preventClickEvent: false
        },
        gatewayPagamentoPix: '',
        dialogoTipoLeitura: false,
        tipoLeitura: '',
        tempoMensagemConfirmacao: null,
      }
    },

    watch: {
      dialogoSolicitaPin() {
        if (this.dialogoSolicitaPin == true) {
          setTimeout(() => {
            document.getElementById('pinTransacao--0').focus()
          }, 400);
        }
      },

      dialogoOperacao() {
        if (this.dialogoOperacao == false) {
          this.respostaTransacao = []
        }
      },

      dialogoPagamentoPix() {
        if (this.dialogoPagamentoPix == false) {
          this.cobrancaAsaas = Object.assign({}, this.defaultCobrancaAsaas)
          clearInterval(this.verificaPagamento)
          this.valorTransacao = "0,00"
        }
      },

      dialogoCartao() {
        if (this.dialogoCartao == false) {
          this.cobrancaAsaasCartao = Object.assign({}, this.defaultCobrancaAsaasCartao)
          this.valorTransacao = "0,00"
        }
      },

      dialogoCadastraConsumidor() {
        if (this.dialogoCadastraConsumidor == false) {
          this.consumidor.nome = ''
          this.consumidor.whatsApp = ''
          this.consumidor.cpf = ''
          this.tecladoCPFConsumidor = false
          this.tecladoNomeConsumidor = false
          this.tecladoWhatsAppConsumidor = false
          this.valorTransacao = "0,00"
        }
      },

      dialogoDadosResgate() {
        if (this.dialogoDadosResgate == false) {
          this.solicitacaoResgate.cpfConsumidor = ''
          this.solicitacaoResgate.qrCodeCartaoConsumo = ''
          this.solicitacaoResgate.tipoChavePix = ''
          this.solicitacaoResgate.chavePix = ''
          this.tecladoChavePix = false
          this.tecladoFavorecidoPix = false
        }
      },

      valorTransacao() {
        if (this.valorTransacao == '') {
          this.valorTransacao = '0,00'
        }
      },

      dialogoConfirmacao() {
        if (this.dialogoConfirmacao == true) {
          this.tempoMensagemConfirmacao = setTimeout(() => {
            this.closeDialog(true)
          }, 5000)
        }
      },
    },

    computed: mapState({
      user: state => state.userObj,
      companyobj: state => state.companyObj,
    }),

    mounted() {
      this.audio = new Audio(require("../assets/beep.mp3"))
      this.pegaParametrosUrl()
      this.pegaConfiguracoes()

      if (!sessionStorage.getItem('tipoLeitura')) {
        this.dialogoTipoLeitura = true
      } else {
        this.tipoLeitura = sessionStorage.getItem('tipoLeitura')
      }
    },

    methods: {
      async pegaConfiguracoes() {
        await axios.get(baseApiUrl + 'Configuracoes/findOne?filter={"fields":{"gatewayPagamentoPix": true}}')
        .then(response => {
          if (response.data) {
            this.gatewayPagamentoPix = response.data.gatewayPagamentoPix
          }
        })
      },

      alteraValor(valor) {
        this.valorTransacao = parseFloat(this.valorTransacao.replace(',','.')) + valor
      },

      onChangeValor(input) {
        this.consumidor.nome = input
      },

      digitaChavePix(input) {
        this.solicitacaoResgate.chavePix = input
      },

      digitaFavorecidoPix(input) {
        this.solicitacaoResgate.favorecidoPix = input
      },

      abreLeituraQRCode(tipo, forma) {
        var vm = this;
        if (this.valorTransacao == '') {
          vm.$refs.chamaSnackbar.snack("#F9A825","Informe um valor para continuar!","ATENÇÃO")
        } else if (parseFloat(this.valorTransacao.replace(',','.')) < 10) {
          vm.$refs.chamaSnackbar.snack("#F9A825","Valor mínimo para recargas é de R$ 10,00","ATENÇÃO")
        } else {
          this.tipoTransacao = tipo
          this.formaTransacao = forma
          if (this.codigoInscricao) {
            if (forma == 'CARTÃO') {
              this.dialogoCartao = true
              this.criarAnosVencimento()
            } else if (forma == 'PIX') {
              if (this.gatewayPagamentoPix == 'ASAAS') {
                this.pagarPixAsaas()
              } else if (this.gatewayPagamentoPix == 'TAPAGO') {
                this.pagarPixTaPago()
              }
            }
          } else {
            this.audio.play()
            this.dialogoCaptura = true
            this.codigoQrCode = ''
            if (this.tipoLeitura == 'LEITOR') {
              setTimeout(() => {
                document.getElementById('campoCaptura').focus()
              }, 100);
            }
          }
        }
      },

      consultarSaldo() {
        this.audio.play()
        this.dialogoConsultaSaldo = true
        this.codigoQrCode = ''
        if (this.tipoLeitura == 'LEITOR') {
          setTimeout(() => {
            document.getElementById('campoConsultaSaldo').focus()
          }, 100);
        }
      },

      solicitaResgate() {
        this.audio.play()
        this.dialogoSolicitaResgate = true
        this.codigoQrCode = ''
        if (this.tipoLeitura == 'LEITOR') {
          setTimeout(() => {
            document.getElementById('campoSolicitaResgate').focus()
          }, 100);
        }
      },

      async solicitarResgate() {
        var vm = this
        this.isLoading = true
        await axios.post(baseApiUrl + 'SolicitacoesResgates/cadastrarSolicitacao', this.solicitacaoResgate)
        .then(response => {
          if (response.data) {
            this.isLoading = false
            this.dialogoDadosResgate = false
            if (response.data.resultado == 'SUCESSO') {
              vm.$refs.chamaSnackbar.snack("#0288D1","Sua solicitação de resgate no valor de R$ " + response.data.saldo + " para a chave Pix " + this.solicitacaoResgate.chavePix + " foi realizada. Aguarde até um dia útil para receber o valor. Caso haja consumação antes da conclusão do resgate, o valor será descontado.","ATENÇÃO")
            } else if (response.data.resultado == 'CPF_DIFERENTE_DO_CONSUMIDOR') {
              vm.$refs.chamaSnackbar.snack("#F9A825","CPF informado é diferente do consumidor","ATENÇÃO")
            } else if (response.data.resultado == 'CARTAO_CONSUMO_NAO_CADASTRADO') {
              vm.$refs.chamaSnackbar.snack("#F9A825","Cartão de consumo não cadastrado","ATENÇÃO")
            } else if (response.data.resultado == 'SOLICITACAO_CADASTRADA_ANTERIORMENTE') {
              vm.$refs.chamaSnackbar.snack("#F9A825","Solicitação de resgate já cadastrada anteriormente. O prazo de conclusão é de até 72hrs após a solicitação.","ATENÇÃO")
            }
          }
        }).catch(() => {
          this.isLoading = false
          vm.$refs.chamaSnackbar.snack("#EF5350","Problema ao criar solicitação de resgate, tente novamente","DESCULPE")
        })
      },

      async decodificar(decodedString) {
        this.codigoQrCode = decodedString
        let verificacao = await this.validaQrCode(this.codigoQrCode, 'resultado')
        if (verificacao == 'SUCESSO') {
          if (this.formaTransacao == 'CARTÃO') {
            this.dialogoCartao = true
            this.criarAnosVencimento()
          } else if (this.formaTransacao == 'PIX') {
            if (this.gatewayPagamentoPix == 'ASAAS') {
              this.pagarPixAsaas()
            } else if (this.gatewayPagamentoPix == 'TAPAGO') {
              this.pagarPixTaPago()
            }
          }
        } else if (verificacao == 'CARTAO_CONSUMO_NAO_CADASTRADO') {
          this.dialogoCadastraConsumidor = true
        } else if (verificacao == 'QRCODE_INVALIDO') {
          var vm = this
          vm.$refs.chamaSnackbar.snack("#F9A825","Cartão de consumo inválido","ATENÇÃO")
        }
        this.dialogoCaptura = false
      },

      async fazerConsultaSaldo(decodedString) {
        var vm = this
        this.isLoading = true
        let resultado = await this.validaQrCode(decodedString, 'resultado')
        if (resultado == 'SUCESSO') {
          let saldo = await this.validaQrCode(decodedString, 'saldo')
          let consumidor = await this.validaQrCode(decodedString, 'consumidor')
          saldo = saldo == '' ? "0,00" : saldo
          vm.$refs.chamaSnackbar.snack("#0288D1", "Seu saldo é de R$ " + saldo, consumidor)
        } else if (resultado == 'CARTAO_CONSUMO_NAO_CADASTRADO') {
          vm.$refs.chamaSnackbar.snack("#F9A825","Cartão de consumo não cadastrado","ATENÇÃO")
        } else if (resultado == 'QRCODE_INVALIDO') {
          vm.$refs.chamaSnackbar.snack("#F9A825","Cartão de consumo inválido","ATENÇÃO")
        }
        this.dialogoConsultaSaldo = false
        this.isLoading = false
      },

      async fazerSolitacaoResgate(decodedString) {
        let vm = this
        this.isLoading = true
        this.dialogoSolicitaResgate = false

        let resultado = await this.validaQrCode(decodedString, 'resultado')
        if (resultado == 'SUCESSO') {
          let saldo = await this.validaQrCode(decodedString, 'saldo')

          if (parseFloat(saldo.replace(',','.')) > 0) {
            this.solicitacaoResgate.qrCodeCartaoConsumo = decodedString
            this.dialogoDadosResgate = true
          } else {
            vm.$refs.chamaSnackbar.snack("#0288D1", "Não há saldo no cartão de consumo para resgatar", "INFORMAÇÃO")
          }
        } else if (resultado == 'CARTAO_CONSUMO_NAO_CADASTRADO') {
          vm.$refs.chamaSnackbar.snack("#F9A825","Cartão de consumo não cadastrado","ATENÇÃO")
        } else if (resultado == 'QRCODE_INVALIDO') {
          vm.$refs.chamaSnackbar.snack("#F9A825","Cartão de consumo inválido","ATENÇÃO")
        }

        this.isLoading = false
      },

      async criarTransacao() {
        var vm = this;
        this.isLoading = true
        let dados = {
          "empresaId": this.user.empresaId,
          "atendenteId": this.user.id,
          "qrCode": this.codigoQrCode,
          "valor": this.valorTransacao,
          "tipoTransacao": this.tipoTransacao,
          "formaTransacao": this.formaTransacao,
          "pinUsuario": this.pinTransacao,
        }
        await axios.post(baseApiUrl + 'CartoesConsumo/novaTransacao', dados)
        .then(response => {
          if (response.data) {
            this.isLoading = false
            this.dialogoCaptura = false
            if (response.data.resultado == 'SUCESSO') {
              this.fechar()
              this.respostaTransacao = response.data
              this.dialogoOperacao = true
            }
            else if (response.data.resultado == 'SALDO_INSUFICIENTE') {
              this.respostaTransacao = response.data
              this.dialogoOperacao = true
            }
            else if (response.data.resultado == 'CARTAO_CONSUMO_NAO_CADASTRADO') {
              this.dialogoCadastraConsumidor = true
            }
            else if (response.data.resultado == 'QRCODE_INVALIDO') {
              vm.$refs.chamaSnackbar.snack("#F9A825","QR Code inválido","ATENÇÃO")
            }
            else if (response.data.resultado == 'TRANSACAO_INFORMADA_INVALIDA') {
              vm.$refs.chamaSnackbar.snack("#F9A825","Transação informada é inválida","ATENÇÃO")
            }
          }
        })
        .catch(error => {
          this.isLoading = false
          vm.$refs.chamaSnackbar.snack("#EF5350","Problema ao criar transação (" + error.response.data.error.message + ")","DESCULPE")
        })
      },

      fechar() {
        this.dialogoSolicitaPin = false
        this.dialogoCaptura = false
        this.dialogoCadastraConsumidor = false
        this.dialogoOperacao = false
        this.dialogoConsultaSaldo = false
        this.dialogoSolicitaResgate = false
        this.pinTransacao = ''
      },

      async criarConsumidor() {
        var vm = this;
        this.isLoading = true
        this.consumidor.qrCode = this.codigoQrCode
        this.consumidor.cpf = this.consumidor.cpf ? this.consumidor.cpf : this.codigoQrCode
        this.consumidor.nome = this.consumidor.nome ? this.consumidor.nome : this.codigoQrCode
        this.consumidor.whatsApp = this.consumidor.whatsApp ? this.consumidor.whatsApp : this.codigoQrCode
        
        await axios.post(baseApiUrl + 'Consumidores/novoConsumidorComCartao', this.consumidor)
        .then(response => {
          if (response.data) {
            if (this.formaTransacao == 'CARTÃO') {
              this.dialogoCartao = true
              this.criarAnosVencimento()
            } else if (this.formaTransacao == 'PIX') {
              if (this.gatewayPagamentoPix == 'ASAAS') {
                this.pagarPixAsaas()
              } else if (this.gatewayPagamentoPix == 'TAPAGO') {
                this.pagarPixTaPago()
              }
            }
          }
        })
        .catch(error => {
          this.isLoading = false
          vm.$refs.chamaSnackbar.snack("#EF5350","Problema ao cadastrar consumidor (" + error.response.data.error.message + ")","DESCULPE")
        })
      },

      async pegaParametrosUrl() {
        this.isLoading = true
        var params = window.location.search.substring(1).split('&');
        if (params[0] != '') {
          var paramArray = {};                        // Criar objeto que vai conter os parametros
          for (var i = 0; i < params.length; i++) {   // Passar por todos os parametros
            var param = params[i].split('=');         // Dividir os parametros chave e valor
            paramArray[param[0]] = param[1];          // Adicionar ao objeto criado antes
          }
          if (paramArray['cod']) {
            this.codigoInscricao = paramArray['cod']
          }
        }
        this.isLoading = false
      },

      criarAnosVencimento() {
        let anoAtual = new Date().toISOString().substring(0, 4)
        let anoFinal = parseInt(new Date().toISOString().substring(0, 4)) + 14

        while ( anoAtual <= anoFinal ) {
          this.anosVencimento.push((anoAtual++).toString());
        }
      },

      carregaQtdParcelas() {
        for (let i = 0; i < this.parcelas.length; i++) {
          if (this.cobrancaAsaasCartao.value == this.parcelas[i].value) {
            this.cobrancaAsaasCartao.installmentCount = this.parcelas[i].parcela
          }
        }
      },

      handleKeyPress(key, campo) {
        if (campo == 'valorTransacao') {
          if (key == 'backspace') {
            this.valorTransacao = this.valorTransacao.substring(0, this.valorTransacao.length - 1);
          } else if (key == 'clear') {
            this.valorTransacao = '0,00'
          } else {
            this.valorTransacao += key
            this.calculaValor()
          }
        } else if (campo == 'consumidor.cpf') {
          if (key == 'backspace') {
            this.consumidor.cpf = this.consumidor.cpf.substring(0, this.consumidor.cpf.length - 1);
          } else if (key == 'clear') {
            this.consumidor.cpf = ''
          } else {
            this.consumidor.cpf += key
          }
        } else if (campo == 'consumidor.whatsApp') {
          if (key == 'backspace') {
            this.consumidor.whatsApp = this.consumidor.whatsApp.substring(0, this.consumidor.whatsApp.length - 1);
          } else if (key == 'clear') {
            this.consumidor.whatsApp = ''
          } else {
            this.consumidor.whatsApp += key
          }
        } else if (campo == 'solicitacaoResgate.cpfConsumidor') {
          if (key == 'backspace') {
            this.solicitacaoResgate.cpfConsumidor = this.solicitacaoResgate.cpfConsumidor.substring(0, this.solicitacaoResgate.cpfConsumidor.length - 1);
          } else if (key == 'clear') {
            this.solicitacaoResgate.cpfConsumidor = ''
          } else {
            this.solicitacaoResgate.cpfConsumidor += key
          }
        }
      },

      calculaValor() {
        const priceString = this.valorTransacao.replace(/\D/g, ''); // Remove não dígitos
        const price = parseInt(priceString, 10); // Converte para número inteiro
        if (!isNaN(price)) {
          // Formate o preço como moeda e exiba no campo de preço
          const formattedPrice = (price / 100).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }).replace('R$', '').trim()
          this.valorTransacao = formattedPrice
        }
      },

      async pagarCartao() {
        var vm = this
        if (!this.cobrancaAsaasCartao.creditCard.holderName || !this.cobrancaAsaasCartao.creditCard.number || !this.cobrancaAsaasCartao.creditCard.cpfCnpj || !this.cobrancaAsaasCartao.creditCard.ccv || !this.cobrancaAsaasCartao.creditCard.expiryMonth || !this.cobrancaAsaasCartao.creditCard.expiryYear || !this.cobrancaAsaasCartao.creditCardHolderInfo.postalCode || !this.cobrancaAsaasCartao.creditCardHolderInfo.addressNumber || !this.cobrancaAsaasCartao.creditCardHolderInfo.email) {
          vm.$refs.chamaSnackbar.snack("#F9A825","Preencha todas as informações!","ATENÇÃO")
        } else {
          this.isLoading = true
          this.cobrancaAsaasCartao.dueDate = moment().format('YYYY-MM-DD')
          this.cobrancaAsaasCartao.value = parseFloat(this.valorTransacao.replace(',','.'))
          this.cobrancaAsaasCartao.remoteIp = await this.pegaIp()
          if (this.codigoInscricao) {
            this.cobrancaAsaasCartao.qrCode = this.codigoInscricao
            this.cobrancaAsaasCartao.description = 'Referente a recarga do cartão de consumo nº ' + this.codigoInscricao + ' no AIConsumer'
          } else {
            this.cobrancaAsaasCartao.qrCode = this.codigoQrCode
            this.cobrancaAsaasCartao.description = 'Referente a recarga do cartão de consumo nº ' + this.codigoQrCode + ' no AIConsumer'
          }
          await axios.post(baseApiUrl + 'Pagamentos/AsaasCobranca', this.cobrancaAsaasCartao)
          .then(async response => {
            if (response.data) {
              this.isLoading = false
              if (this.codigoInscricao) {
                this.saldoCartao = await this.validaQrCode(this.codigoInscricao, 'saldo')
              } else {
                this.saldoCartao = await this.validaQrCode(this.codigoQrCode, 'saldo')
              }
              this.dialogoConfirmacao = true
            }
          }).catch(() => {
            this.isLoading = false
            vm.$refs.chamaSnackbar.snack("#EF5350","Problema ao criar transação, tente novamente","DESCULPE")
          })
        }
      },

      async pagarPixAsaas() {
        var vm = this
        this.isLoading = true
        this.cobrancaAsaas.value = parseFloat(this.valorTransacao.replace(',','.'))
        this.cobrancaAsaas.dueDate = moment().format('YYYY-MM-DD')
        if (this.codigoInscricao) {
          this.cobrancaAsaas.qrCode = this.codigoInscricao
          this.cobrancaAsaas.description = 'Referente a recarga do cartão de consumo nº ' + this.codigoInscricao + ' no AIConsumer'
        } else {
          this.cobrancaAsaas.qrCode = this.codigoQrCode
          this.cobrancaAsaas.description = 'Referente a recarga do cartão de consumo nº ' + this.codigoQrCode + ' no AIConsumer'
        }
        await axios.post(baseApiUrl + 'Pagamentos/AsaasCobranca', this.cobrancaAsaas)
        .then(response => {
          if (response.data) {
            this.isLoading = false
            this.cobrancaPix.id = response.data.paymentId
            this.cobrancaPix.qrCode = "data:image/jpeg;base64," + response.data.qrCode.encodedImage
            this.cobrancaPix.chaveCopiaCola = response.data.qrCode.payload
            this.dialogoPagamentoPix = true
            this.consultaPagamentoPixAsaas()
          }
        }).catch(() => {
          this.isLoading = false
          vm.$refs.chamaSnackbar.snack("#EF5350","Problema ao criar transação, tente novamente","DESCULPE")
        })
      },

      async consultaPagamentoPixAsaas() {
        this.verificaPagamento = setInterval(async function() {
          await axios.post(baseApiUrl + 'Pagamentos/AsaasCobrancaConsulta', {"paymentId": this.cobrancaPix.id}).then(async response => {
            if (response.data.status == 'RECEIVED') {
              clearInterval(this.verificaPagamento)
              if (this.codigoInscricao) {
                this.saldoCartao = await this.validaQrCode(this.codigoInscricao, 'saldo')
              } else {
                this.saldoCartao = await this.validaQrCode(this.codigoQrCode, 'saldo')
              }
              this.dialogoPagamentoPix = false
              this.dialogoConfirmacao = true
            }
          })
        }.bind(this), 5000)
      },

      async pagarPixTaPago() {
        var vm = this
        this.isLoading = true
        let dados = {
          "qrCode": "",
          "valor": parseFloat(this.valorTransacao.replace(',','.')),
          "descricao": ""
        }

        if (this.codigoInscricao) {
          dados.qrCode = this.codigoInscricao
          dados.descricao = 'Referente a recarga do cartão de consumo nº ' + this.codigoInscricao + ' no AIConsumer'
        } else {
          dados.qrCode = this.codigoQrCode
          dados.descricao = 'Referente a recarga do cartão de consumo nº ' + this.codigoQrCode + ' no AIConsumer'
        }

        await axios.post(baseApiUrl + 'Pagamentos/taPagoCobranca', dados)
        .then(response => {
          if (response.data) {
            this.isLoading = false
            this.cobrancaPix.id = response.data.transactionId
            this.cobrancaPix.qrCode = "data:" + response.data.instantPayment.generateImage.mimeType + ";base64," + response.data.instantPayment.generateImage.imageContent
            this.cobrancaPix.chaveCopiaCola = response.data.instantPayment.textContent
            this.dialogoPagamentoPix = true
            this.consultaPagamentoPixTaPago()
          }
        })
        .catch(() => {
          this.isLoading = false
          vm.$refs.chamaSnackbar.snack("#EF5350","Problema ao criar transação, tente novamente","DESCULPE")
        })
      },

      async consultaPagamentoPixTaPago() {
        this.verificaPagamento = setInterval(async function() {
          await axios.post(baseApiUrl + 'Pagamentos/taPagoCobrancaConsulta', {"paymentId": this.cobrancaPix.id})
          .then(async response => {
            if (response.data.status == 'APPROVED') {
              clearInterval(this.verificaPagamento)
              if (this.codigoInscricao) {
                this.saldoCartao = await this.validaQrCode(this.codigoInscricao, 'saldo')
              } else {
                this.saldoCartao = await this.validaQrCode(this.codigoQrCode, 'saldo')
              }
              this.dialogoPagamentoPix = false
              this.dialogoConfirmacao = true
            }
          })
        }.bind(this), 5000)
      },

      async pegaIp() {
        let ip
        await axios.get('https://api.ipify.org/?format=json')
        .then(response => {
          if (response.data) {
            ip = response.data.ip
          } else {
            ip = '127.0.0.1'
          }
        })
        .catch(() => {
          ip = '127.0.0.1'
        })
        return ip
      },

      doCopy(id) {
        try {
          let copyText = document.getElementById(id);
          copyText.select();
          copyText.setSelectionRange(0, 99999); /* Para dispositivos móveis */
          document.execCommand("copy");
          this.snackbar = true
          this.textoSnackbar = 'Chave copiada para a área de transferência!'
        } catch (error) {
          this.snackbar = true
          this.textoSnackbar = 'Problema ao copiar chave para a área de transferência'
        }
      },

      closeDialog(reload = false) {
        clearTimeout(this.tempoMensagemConfirmacao)
        this.dialogoConfirmacao = false
        this.dialogoPagamentoPix = false
        if (reload) {
          window.location.reload()
        }
      },

      async validaQrCode(qrCode, atributo) {
        let resultado
        await axios.post(baseApiUrl + 'QRCodes/validaQrcode', {"qrCode": qrCode})
        .then(response => {
          if (response.data) {
            resultado = response.data[atributo]
          }
        })
        return resultado
      },

      focusInput(campo) {
        if (campo == 'consumidor.cpf') {
          this.tecladoCPFConsumidor = true
          this.tecladoNomeConsumidor = false
          this.tecladoWhatsAppConsumidor = false
        } else if (campo == 'consumidor.nome') {
          this.tecladoCPFConsumidor = false
          this.tecladoNomeConsumidor = true
          this.tecladoWhatsAppConsumidor = false
        } else if (campo == 'consumidor.whatsApp') {
          this.tecladoCPFConsumidor = false
          this.tecladoNomeConsumidor = false
          this.tecladoWhatsAppConsumidor = true
        } else if (campo == 'solicitacaoResgate.chavePix') {
          this.tecladoChavePix = true
          this.tecladoFavorecidoPix = false
        } else if (campo == 'solicitacaoResgate.favorecidoPix') {
          this.tecladoChavePix = false
          this.tecladoFavorecidoPix = true
        }
      },

      configuraTipoLeitura(tipo) {
        this.tipoLeitura = tipo
        sessionStorage.setItem('tipoLeitura', tipo)
        this.dialogoTipoLeitura = false
      },
    },
    directives: {money: VMoney}
  }
</script>

<style scoped>
  .limiter {
    width: 100%;
    margin: 0 auto;
  }

  .container-login {
    width: 100%;
    min-height: 100vh;
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    align-items: center;
    padding: 15px;
    background: linear-gradient(to right, #474d55, #474d55);
    background-repeat: no-repeat;
    position: relative;
    z-index: 1;
  }

  .texto {
    font-weight: bold;
    color: #00253E;
    font-size: 17px;
  }

  .login {
    min-width: 80%;
    border-radius: 15px;
    background-color: #fff;
    opacity: 0.9;
    padding-top: 15px;
    padding-bottom: 15px;
  }

  .login-title {
    display: block;
    margin-left: auto;
    margin-right: auto;
    text-align: center
  }

  a {
    text-decoration: none
  }
</style>